// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"7102ac37","455":"0f03b739","977":"8b313f32"}[chunkId] + ".chunk.js";
};